import produce from "immer";

import {
  type VerificationService,
  type FormSelectChoice,
  type MilitaryPersonalInfoViewModel,
} from "../../lib/types/types";

export const updateMilitaryViewModel = (
  key: keyof MilitaryPersonalInfoViewModel,
  value: any,
  verificationService: VerificationService,
  availableStatuses: FormSelectChoice[],
): MilitaryPersonalInfoViewModel => {
  const viewModel = verificationService.viewModel as MilitaryPersonalInfoViewModel;
  return produce(viewModel, (draft: MilitaryPersonalInfoViewModel) => {
    (draft[key] as any) = value;

    // Reset military-managed skip flags before reapplying.
    const militaryManagedFields = ["status"];
    draft.fieldsToSkipValidation = (draft.fieldsToSkipValidation || []).filter(
      (id) => !militaryManagedFields.includes(id),
    );

    if (!availableStatuses || availableStatuses.length === 0) {
      draft.fieldsToSkipValidation.push("status");
    }

    if (key === "status") {
      draft.organization = { id: 0, name: "" };
    }
  });
};
